import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const Card = styled.div`
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  border: 1px solid #e5e7eb;
  padding: 1.5rem 2rem;
  margin-bottom: 1.5rem;
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-wrap: wrap;
`;
const Rate = styled.span`
  font-size: 2rem;
  font-weight: 700;
  color: #232d4d;
`;
const EditInput = styled.input`
  font-size: 1.3rem;
  font-weight: 600;
  width: 120px;
  padding: 0.4rem 0.7rem;
  border: 1px solid #d1d5db;
  border-radius: 7px;
  margin-right: 1rem;
`;
const SaveBtn = styled.button`
  background: #232d4d;
  color: #fff;
  border: none;
  border-radius: 7px;
  padding: 0.5rem 1.3rem;
  font-weight: 600;
  font-size: 1rem;
  cursor: pointer;
`;

export default function TaxRateCard({ onTaxRateChange }) {
  const [taxRate, setTaxRate] = useState(() => {
    const stored = localStorage.getItem('taxRate');
    return stored ? Number(stored) : 5; // Default 5% convenience fee
  });
  const [edit, setEdit] = useState(false);
  const [input, setInput] = useState(taxRate);
  
  useEffect(() => { 
    setInput(taxRate); 
  }, [taxRate]);
  
  function handleSave() {
    setTaxRate(input);
    localStorage.setItem('taxRate', input);
    setEdit(false);
    if (onTaxRateChange) onTaxRateChange(input);
  }
  
  return (
    <Card>
      <div style={{flex:1}}>
        <div style={{fontWeight:600, fontSize:'1.1rem', color:'#6b7280'}}>Current Tax Rate</div>
        {edit ? (
          <>
            <EditInput 
              type="number" 
              min={0} 
              max={100} 
              value={input} 
              onChange={e=>setInput(Number(e.target.value))} 
            />
            <span style={{fontSize:'1.3rem', fontWeight:600, marginRight: '1rem'}}>%</span>
            <SaveBtn onClick={handleSave}>Save</SaveBtn>
            <SaveBtn 
              style={{background:'#eee',color:'#232d4d',marginLeft:8}} 
              onClick={()=>{setEdit(false);setInput(taxRate);}}
            >
              Cancel
            </SaveBtn>
          </>
        ) : (
          <>
            <Rate>{taxRate}%</Rate>
            <SaveBtn style={{marginLeft:18}} onClick={()=>setEdit(true)}>Edit</SaveBtn>
          </>
        )}
      </div>
      <div style={{fontSize:'1.05rem', color:'#888'}}>This tax rate will be applied to all bookings.</div>
    </Card>
  );
}
